import React, { Fragment } from 'react';
import styled from 'styled-components';

import Link from '../components/Link';

const Span = styled.span`
  color: #009B8A;

  .dark-background & {
    color: #7DDABA;
  }
`;

export const markdownOptions = {
  overrides: {
    a: {
      component({ href, ...rest }) {
        return (<Link to={href} {...rest} />);
      },
    },
    em: {
      component: Span,
    },
  },
  forceInline: true,
  wrapper: Fragment,
};
